import { OrbitLogo } from "~/components/icons/logos"
import { cn } from "~/lib/utils"

export const STEPS = {
	WELCOME: 0,
	ORGANIZATION: 1,
	INVITE: 2,
	COMPLETE: 3
} as const

const steps = [
	{ name: "Create your Account", step: -1, forceActive: true },
	{ name: "Welcome!", step: STEPS.WELCOME },
	{ name: "Create an Organization", step: STEPS.ORGANIZATION },
	{ name: "Invite Users", step: STEPS.INVITE },
	{ name: "Blast Off!", step: STEPS.COMPLETE }
] satisfies { name: string; step: number; forceActive?: boolean }[]

export default function Steps({ currentStep }: { currentStep: number }) {
	return (
		<div className="h-full w-full flex flex-row text-sm font-medium items-start relative">
			{steps.map((step, i) => {
				const active = step.forceActive ?? currentStep >= step.step
				return (
					<div
						key={step.name}
						className="w-32 flex flex-col basis-0 items-center relative grow"
					>
						{i !== 0 && currentStep >= step.step && (
							<Line className="-left-1/2" />
						)}
						<Dot active={active} orbit={i === steps.length - 1} />
						<div className="mt-4">{step.name}</div>
						{currentStep > step.step && <Line className="left-1/2" />}
					</div>
				)
			})}
		</div>
	)
}

const Dot = ({
	active,
	orbit = false
}: {
	active: boolean
	orbit?: boolean
}) => {
	return (
		<>
			{orbit ? (
				<OrbitLogo
					className="w-4 h-4 text-icons absolute -top-0.5"
					fill="currentColor"
					width={16}
				/>
			) : null}
			<div
				className={cn(
					"w-2 h-2 bg-icons rounded-full",
					active && "bg-primary",
					orbit && "bg-inherit"
				)}
			/>
		</>
	)
}

const Line = ({ className }: { className: string }) => {
	return (
		<div
			className={cn(
				"absolute -left-1/2 top-px w-full h-1.5 bg-primary",
				className
			)}
		/>
	)
}
